import {
  PAYPAL_CHECKER_REQUEST,
  PAYPAL_CHECKER_ERROR,
  PAYPAL_CHECKER_RESET,
  PAYPAL_CHECKER_SUCCESS,
} from "./ActionType";
export const initialState = {
  isRequest: false,
  isSuccess: false,
  isError: false,
  paypalchecker: null,
  error: null,
  shopId: null,
  requestId: null,
};

const hasRequestMeta = (meta) =>
  typeof meta?.shopId === "string" &&
  meta.shopId.length > 0 &&
  typeof meta?.requestId === "string" &&
  meta.requestId.length > 0;

const isActiveRequest = (state, meta) =>
  hasRequestMeta(meta) &&
  state.shopId === meta.shopId &&
  state.requestId === meta.requestId;

const paypalCheckerReducer = (state = initialState, action) => {
  switch (action.type) {
    case PAYPAL_CHECKER_REQUEST:
      if (!hasRequestMeta(action.meta)) return state;
      return {
        isRequest: true,
        isSuccess: false,
        isError: false,
        paypalchecker: null,
        error: null,
        shopId: action.meta.shopId,
        requestId: action.meta.requestId,
      };
    case PAYPAL_CHECKER_SUCCESS:
      if (!isActiveRequest(state, action.meta)) return state;
      return {
        ...state,
        isRequest: false,
        isSuccess: true,
        isError: false,
        paypalchecker: action.payload,
        error: null,
      };

    case PAYPAL_CHECKER_ERROR:
      if (!isActiveRequest(state, action.meta)) return state;
      return {
        ...state,
        isRequest: false,
        isSuccess: false,
        isError: true,
        paypalchecker: null,
        error: action.payload,
      };
    case PAYPAL_CHECKER_RESET:
      return initialState;
    default:
      return state;
  }
};

export default paypalCheckerReducer;
